import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

export function useTheme() {
  const [theme, setTheme] = useState<Theme>('light');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    // Force light theme always
    setTheme('light');
    const htmlElement = document.documentElement;
    htmlElement.classList.remove('dark');
    htmlElement.setAttribute('data-theme', 'light');
    localStorage.setItem('theme', 'light');

    // // Проверяем сохраненную тему в localStorage и применяем её
    // const savedTheme = localStorage.getItem('theme') as Theme | null
    // const htmlElement = document.documentElement

    // if (savedTheme === 'dark') {
    //   setTheme('dark')
    //   htmlElement.classList.add('dark')
    //   htmlElement.setAttribute('data-theme', 'dark')
    // } else if (savedTheme === 'light') {
    //   setTheme('light')
    //   htmlElement.classList.remove('dark')
    //   htmlElement.setAttribute('data-theme', 'light')
    // } else {
    //   // Если тема не сохранена, проверяем системную тему или используем светлую по умолчанию
    //   const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    //   const defaultTheme: Theme = 'light'
    //   // const defaultTheme: Theme = prefersDark ? 'dark' : 'light'

    //   setTheme(defaultTheme)
    //   // if (defaultTheme === 'dark') {
    //   //   htmlElement.classList.add('dark')
    //   //   htmlElement.setAttribute('data-theme', 'dark')
    //   // } else {
    //   //   htmlElement.classList.remove('dark')
    //   //   htmlElement.setAttribute('data-theme', 'light')
    //   // }

    //   // Сохраняем выбранную по умолчанию тему
    //   localStorage.setItem('theme', defaultTheme)
    // }

    // // Слушаем изменения системной темы
    // const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    // const handleSystemThemeChange = (e: MediaQueryListEvent) => {
    //   // Обновляем тему только если пользователь не выбрал тему вручную
    //   const userTheme = localStorage.getItem('theme')
    //   if (!userTheme) {
    //     const newTheme: Theme = e.matches ? 'dark' : 'light'
    //     localStorage.setItem('theme', newTheme)
    //     setTheme(newTheme)

    //     if (newTheme === 'dark') {
    //       htmlElement.classList.add('dark')
    //       htmlElement.setAttribute('data-theme', 'dark')
    //     } else {
    //       htmlElement.classList.remove('dark')
    //       htmlElement.setAttribute('data-theme', 'light')
    //     }
    //   }
    // }

    // mediaQuery.addEventListener('change', handleSystemThemeChange)

    // return () => {
    //   mediaQuery.removeEventListener('change', handleSystemThemeChange)
    // }
  }, []);

  const toggleTheme = () => {
    // Force light theme always - no toggle allowed
    setTheme('light');
    localStorage.setItem('theme', 'light');
    const htmlElement = document.documentElement;
    htmlElement.classList.remove('dark');
    htmlElement.setAttribute('data-theme', 'light');
  };

  const setThemeManually = (newTheme: Theme) => {
    // Force light theme always - ignore any manual theme changes
    setTheme('light');
    localStorage.setItem('theme', 'light');
    const htmlElement = document.documentElement;
    htmlElement.classList.remove('dark');
    htmlElement.setAttribute('data-theme', 'light');
  };

  useEffect(() => {
    if (theme === 'dark') {
      toggleTheme();
    }
  }, [theme]);

  // Вычисляем isDark на основе текущего состояния theme
  const isDark = theme === 'dark';

  return {
    theme,
    toggleTheme,
    setTheme: setThemeManually,
    isDark,
    mounted,
  };
}
